<template>
    <div class="m-related">
        <div class="m-related__header">
            <p class="m-related__title a-title a-title--small">Zamów również</p>
        </div>
        <div
            v-if="featuredPackages"
            class="m-related__content"
        >
            <product-box-related
                v-for="product in featuredPackages"
                v-bind:key="product.id"
                :address-id="currentAddressId"
                :product="product"
            />
        </div>
    </div>
</template>

<script>
import ProductBoxRelated from '@/components/ProductBoxRelated'
export default {
    components: {
        ProductBoxRelated
    },
    computed: {
        warehouseId() {
            return this.$store.getters.customerAddressWarehouseId(this.currentAddressId)
        },
        externalSupplier() {
            return this.$store.getters.customerAddressExternalSupplier(this.currentAddressId)
        },
        featuredPackages() {
            return this.$store.getters.featuredPackages(this.warehouseId, this.externalSupplier)
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        }
    }
}
</script>
